import { useEffect, useState } from "react";
import Banks from "./banks.svg";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

// Import bank logos
import amexLogo from "./logos/AMEX.svg";
import axisLogo from "./logos/AXIS.svg";
import barodaLogo from "./logos/Baroda.svg";
import citiLogo from "./logos/CITI.svg";
import federalLogo from "./logos/Federal.svg";
import hdfcLogo from "./logos/HDFC.svg";
import hsbcLogo from "./logos/HSBC.svg";
import iciciLogo from "./logos/ICICI.svg";
import idfcLogo from "./logos/IDFC.svg";
import indusindLogo from "./logos/INdus.svg";
import kotakLogo from "./logos/Kotak.svg";
import rblLogo from "./logos/RBL.svg";
import standardCharteredLogo from "./logos/Standard CHartered.svg";
import sbiLogo from "./logos/SBI.svg";
import yesBankLogo from "./logos/YES.svg";
import CardGif from "../../components/Arthmate/Modules/BasicInfo/Cards 2.gif";
import Faster from "./faster.svg";
import axios from "axios";
import { env } from "../../environment/environment";
import CarepayLogo from '../../assets/Logo-carepay.svg';


export default function CreditCardPopupNew({
  userId,
  showPopOver,
  setShowPopOver,
  setnoCostPrimary,
  noBtnClick = () => { },
}) {
  const [showAllBanks, setShowAllBanks] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [closing, setClosing] = useState(false);
  const [nudgeCards, setNudgeCards] = useState([]);

  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [orderData, setOrderData] = useState('');
  const [loanId, setLoanId] = useState('');
  const [loanData, setLoanData] = useState('');

  { console.log(userId, 'userid') }

  const handleClose = (type) => {
    if (type === "remind") {
      // setnoCostPrimary(true);
      handleClose();
    }
    setClosing(true);
    setTimeout(() => {
      setShowPopOver(false);
      setClosing(false);
      noBtnClick();
    }, 400);
  };
  const checknudge = (treatmentAmount, loanId) => {
    if (treatmentAmount) {
      axios
        .post(
          "https://credit.carepay.money/api/credit-card-limit-estimator",
          {
            userId: userId,
            treatmentAmount,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Raw API response:", response.data);

          const cardList = Array.isArray(response.data)
            ? response.data
            : response.data?.data || [];

          const nudged = cardList.filter((c) => c.nudge);

          if (nudged.length > 0) {
            // setnoCostPrimary(true);

            setNudgeCards(nudged.slice(0, 2));
            axios
              .get(`${env.api_Url}sendCCLinkToBorrower?loanId=${loanId}`)
              .then((response) => {
                console.log(response)
              })
          }
        })
        .catch((error) => {
          console.error("❌ API Error:", error);
        });
    }
  };
  useEffect(() => {
    axios
      .get(env.api_Url + "userDetails/getLoanDetailsByUserId?userId=" + userId)
      .then((loanData) => {
        console.log(loanData);
        setLoanData(loanData.data.data);
        checknudge(loanData.data.data.treatmentAmount, loanData.data.data.loanId);
      });
  }, [])

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    script.onerror = () => console.error("Failed to load Razorpay script.");
    document.body.appendChild(script);
  }, []);


  const paymentHandler = (data) => {

    if (!scriptLoaded) {
      console.error("Razorpay script not loaded.");
      return;
    }

    const options = {
      key: data.key,
      amount: data.amount,
      currency: "INR",
      name: data.userName,
      description: "",
      image: CarepayLogo,
      order_id: data.orderId,
      callback_url: data.callback_url,
      redirect: "false",
      prefill: {
        name: data.userName,
        email: "",
        contact: data.userMobileNo
      },
      notes: { address: "Gurugram" },
      theme: { color: "#514C9F" },
      config: {
        display: {
          hide: [
            { method: 'upi' },
            { method: 'netbanking' },
            { method: 'card' },
            { method: 'wallet' }
          ],
          preferences: {
            show_default_blocks: true,
          },
        },
      }
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };
  const createOrderAndPay = (orderData) => {
    if (orderData) {
      paymentHandler(orderData);
    }
  };
  const fetchLoanAndOrderData = async () => {
    try {
      const loanRes = await axios.get(`${env.api_Url}userDetails/getLoanDetailsByUserId?userId=${userId}`);
      const loan = loanRes?.data?.data?.loanId;
      console.log(loanRes?.data?.data?.loanId)
      if (!loan) return;

      setLoanId(loan);

      // const checkoutRes = await axios.get(`${env.api_Url}getDataForCheckoutApi?loanId=${loan}`);
      // if (checkoutRes.data.message === 'success') {
      //   setOrderData(checkoutRes.data.data);
      //   createOrderAndPay(checkoutRes.data.data)

      // } else {
      const orderRes = await axios.get(`${env.api_Url}razorPayCreateOrder?loanId=${loan}`);
      if (orderRes.data.status === 200) {
        const newCheckoutRes = await axios.get(`${env.api_Url}getDataForCheckoutApi?loanId=${loan}`);
        if (newCheckoutRes.data.status === 200) {
          setOrderData(newCheckoutRes.data.data);
          createOrderAndPay(newCheckoutRes.data.data)
        }
      }
      // }
    } catch (err) {
      console.error("Error in fetching loan/order data", err);
    }
  };

  // Master list of banks
  const banks = [
    { name: "American Express", logo: amexLogo },
    { name: "Axis Bank", logo: axisLogo },
    { name: "Bank of Baroda", logo: barodaLogo },
    { name: "CITI Bank", logo: citiLogo },
    { name: "Federal Bank", logo: federalLogo },
    { name: "HDFC Bank", logo: hdfcLogo },
    { name: "HSBC Bank", logo: hsbcLogo },
    { name: "ICICI Bank", logo: iciciLogo },
    { name: "IDFC Bank", logo: idfcLogo },
    { name: "IndusInd Bank", logo: indusindLogo },
    { name: "Kotak Bank", logo: kotakLogo },
    { name: "RBL Bank", logo: rblLogo },
    { name: "Standard Chartered Bank", logo: standardCharteredLogo },
    { name: "State Bank of India", logo: sbiLogo },
    { name: "Yes Bank", logo: yesBankLogo },
  ];

  const topCards = nudgeCards
    .map((card) => {
      const bank = banks.find(
        (b) =>
          b.name.toLowerCase().includes(card.credit_card_name.toLowerCase())
      );
      return bank ? { ...card, ...bank } : null;
    })
    .filter(Boolean)
    .slice(0, 2);

  return (
    <div className="blur-bg" >
      <div
        className={`bankPopupModal ${showPopOver && !closing
          ? "open slideUpBounce"
          : closing
            ? "close slideDownBounce"
            : ""
          }`}
        onClick={handleClose}
      >
        <div className="bankPopupCard" onClick={(e) => e.stopPropagation()}>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ marginTop: "10px", marginBottom: "10px", width: "75%" }}>

              <br />
              <p style={{ fontSize: '14px' }}>
                Pay for your treatment in <br />
                no-cost EMIs using your credit card.
              </p>
            </div>
            <div style={{ marginTop: "5px", marginBottom: "10px", width: "15%" }}>
              <img src={CardGif} style={{ width: "100%" }} alt="Card Gif" />
            </div>
          </div>

          <div style={{ marginTop: 12 }}>
            {topCards.map((b) => (
              <div
                key={b.credit_card_name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 6,
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    border: "2px solid #e6e6e6",
                    borderRadius: "5px",
                    width: "40px",
                    height: "40px",
                  }}
                >
                  <img src={b.logo} alt={b.name} style={{ width: "100%" }} />
                </div>
                <div style={{ marginLeft: 10 }}>
                  <span style={{ fontSize: 14 }}>{b.name}</span>
                  {/* <br /> */}
                  {/* <small style={{ color: "#666" }}>
                  Limit: ₹{b.estimated_limit?.toLocaleString()}
                </small> */}
                </div>
              </div>
            ))}
          </div>

          {/* +13 Banks section */}
          <div
            style={{
              background: "#EBFEED",
              padding: "10px",
              borderRadius: "5px",
              marginBottom: "10px",
              marginTop: "15px",
              border: "1px solid #d8e4d8",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={Banks} alt="Banks" style={{ height: "20px" }} />
                &nbsp;&nbsp;
                <div style={{ marginTop: "6px", color: "#909890" }}>+13 banks</div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "#909890",
                }}
                onClick={() => setShowAllBanks(!showAllBanks)}
              >
                {showAllBanks ? "Close" : "View all"}
                {showAllBanks ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </div>
            </div>

            {showAllBanks && (
              <div
                style={{
                  marginTop: "10px",
                  maxHeight: "360px",
                  overflowY: "auto",
                  borderRadius: "5px",
                }}
              >
                <ul
                  style={{
                    color: "#333",
                    listStyle: "none",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {banks.map((bank, index) => (
                    <li
                      key={index}
                      style={{
                        padding: "10px",
                        borderBottom:
                          index !== banks.length - 1 ? "1px solid #ddd" : "none",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        background:
                          selectedBank === bank.name ? "#E3F2FD" : "transparent",
                      }}
                      onClick={() => setSelectedBank(bank.name)}
                    >
                      <img
                        src={bank.logo}
                        alt={bank.name}
                        style={{
                          width: "30px",
                          height: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <span>{bank.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div
            style={{
              justifyContent: "center",
              color: "#45934a",
              fontWeight: "700",
              fontStyle: "italic",
              display: "flex",
              marginTop: "20px",
            }}
          >
            <img src={Faster} alt="Faster" />
            &nbsp;Quick process
          </div>
          <button
            style={{ marginTop: "5px" }}
            className="submit"
            onClick={() => fetchLoanAndOrderData()}
          >
            Continue with card EMIs
          </button>
          <button
            style={{ background: "#ECEBFF", color: "#514C9F", marginTop: "0px" }}
            className="submit"
            onClick={() => handleClose("remind")}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
